export const StaticMapUrl = ({ latitude, longitude, zoom = 15, size = { width: 500, height: 500 }, scale = 1, format = 'png', mapType = 'roadmap', apiKey = process.env.REACT_APP_MAP_KEY }) => {
	const rootUrl = 'https://maps.googleapis.com/maps/api/staticmap';
	const markerParams = `markers=${latitude},${longitude}`;
	const apiKeyParam = `key=${apiKey}`;
	const { width, height } = size;

	return `${rootUrl}?center=${latitude},${longitude}&zoom=${zoom}&scale=${scale}&size=${width}x${height}&maptype=${mapType}&format=${format}&${markerParams}&${apiKeyParam}`;
};
